"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Adaptive = "adaptive";
var Hidden = "hidden";
var Visible = "visible";
var isOneOf = function isOneOf(value) {
  switch (value) {
    case Adaptive:
    case Hidden:
    case Visible:
      return true;
    default:
      return false;
  }
};
var _default = {
  Adaptive: Adaptive,
  Hidden: Hidden,
  Visible: Visible,
  isOneOf: isOneOf
};
exports["default"] = _default;